
import { IncomeExpense } from "../../classes"

const IncomeExpenseModule = {
  namespaced: true,
  state: {
    incomeExpenses: null,
  },
  mutations: {
    setIncomeExpenses(state, incomeExpenses) {
      state.incomeExpenses = incomeExpenses || []
    },
    clearIncomeExpenses(state){
      state.incomeExpenses = null
    },
    addIncomeExpenses(state, incomeExpenses) {
      state.incomeExpenses = incomeExpenses.concat(state.incomeExpenses)
    },
    updateIncomeExpense(state, incomeExpense) {
      if (state.incomeExpenses?.length) {
        let index = state.incomeExpenses.findIndex(i => i.id === incomeExpense.id);
        if (index > -1) {
          state.incomeExpenses[index] = incomeExpense;
        } else {
          state.incomeExpenses.unshift(incomeExpense)
        }
        const temp = state.incomeExpenses
        state.incomeExpenses = []
        state.incomeExpenses = temp
      } else {
        state.incomeExpenses = [incomeExpense]
      }
    },
    removeIncomeExpense(state, incomeExpenseId) {
      if (state.incomeExpenses) {
        let index = state.incomeExpenses.findIndex(d => d.id == incomeExpenseId)
        if (index > -1) {
          state.incomeExpenses.splice(index, 1)
        }
      }
    },
    updateIncomeExpenseCategory(state, category) {
      if (state.incomeExpenses?.length) {
        state.incomeExpenses.forEach(i => {
          if (i.categoryItem.objectId == category.objectId) {
            i.category = category.name
            i.categoryItem = category
          }
        })
      }
    }
  },
  actions: {
    getIncomeExpenseBetweenDateByMarket: async ({ commit }, fromData) => {
      try{
        commit("clearIncomeExpenses")
        const data = await IncomeExpense.getIncomeExpenseBetweenDateByMarket(fromData)
        commit("setIncomeExpenses", data)
        return data
      }catch(error){
        throw error
      }
    },
  },
  getters: {
    getIncomeExpenses: (state) => state.incomeExpenses?.sort((a, b) => new Date(b.date) - new Date(a.date)),
  },
};
export default IncomeExpenseModule;
